// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__W1TTO","btn--primary":"Button_btn--primary__Pm4Sn","btn--accent":"Button_btn--accent__-WDwx","btn--loading":"Button_btn--loading__z4ePh"};